import { Component, Inject } from '@angular/core';
import { BaseStoredItem } from './stored-items-browser.component';

@Component({
    selector: 'app-default-item-renderer',
    template: `
    <div class="tw-group tw-flex tw-items-center tw-gap-2">
      <button
        (click)="selectItem()"
        class="tw-flex-1 tw-text-left tw-bg-gray-800 tw-bg-opacity-30 tw-border tw-border-solid tw-border-gray-700 tw-border-opacity-50 tw-rounded-xl tw-p-3 tw-transition-colors tw-duration-200 hover:tw-bg-gray-800 hover:tw-bg-opacity-50 hover:tw-border-teal-600 hover:tw-border-opacity-60 focus:tw-outline-none"
        aria-label="Select this item">
        <div class="tw-flex tw-items-center tw-justify-between">
          <div>
            <div class="tw-text-white tw-font-medium">{{ item?.name || 'Unnamed Item' }}</div>
            <div *ngIf="item?.description" class="tw-text-sm tw-text-gray-400 tw-mt-1">
              {{ item.description }}
            </div>
            <div *ngIf="showCreator && item.createdBy" class="tw-flex tw-items-center tw-gap-1 tw-mt-1">
              <mat-icon class="tw-text-gray-500 tw-text-[14px]">person_outline</mat-icon>
              <span class="tw-text-xs tw-text-gray-500">{{ item.createdBy }}</span>
            </div>
          </div>
          <mat-icon
            class="tw-text-lg tw-leading-5 tw-font-bold tw-text-teal-500 tw-opacity-0 group-hover:tw-opacity-80 tw-transition-opacity tw-duration-200">
            arrow_forward
          </mat-icon>
        </div>
      </button>
      
      <button
        *ngIf="allowDelete"
        (click)="deleteItem($event)"
        class="tw-opacity-0 group-hover:tw-opacity-100 tw-transition-opacity tw-duration-200 focus:tw-opacity-100 tw-w-8 tw-h-8 tw-rounded-full tw-text-red-400 tw-bg-gray-700 hover:tw-bg-gray-600 tw-flex tw-items-center tw-justify-center"
        aria-label="Delete this item">
        <mat-icon class="tw-text-lg">delete_outline</mat-icon>
      </button>
    </div>
  `,
    styles: [],
    standalone: false
})
export class DefaultItemRendererComponent<T extends BaseStoredItem> {
  constructor(
    @Inject('item') public item: T,
    @Inject('allowDelete') public allowDelete: boolean,
    @Inject('showCreator') public showCreator: boolean,
    @Inject('onItemSelected') private onItemSelected: (item: T) => void,
    @Inject('onItemDeleted') private onItemDeleted: (item: T) => void
  ) {}

  selectItem() {
    if (this.item) {
      this.onItemSelected(this.item);
    }
  }

  deleteItem(event: Event) {
    event.stopPropagation();
    if (this.item) {
      this.onItemDeleted(this.item);
    }
  }
}
